import Link from "next/link";
import React from "react";
import getOriginUrl from "@lib/utils/url/getOriginUrl";
import StructuredDataTag from "./StructuredDataTag";
import { useTranslation } from "next-i18next";

export type Breadcrumb = {
  title: string | ((t: (key: string) => string) => string);
  url?: string;
};

export const BREADCRUMBS: {
  [key: string]: Breadcrumb;
} = {
  HOME: {
    title: (t) => t("home"),
    url: "/",
  },

  JOBS: {
    title: (t) => t("jobs"),
    url: "/jobs/search",
  },
};

function Breadcrumbs({ breadcrumbs }: { breadcrumbs: Breadcrumb[] }) {
  const { t } = useTranslation("breadcrumbs");

  return (
    <div>
      <hr />

      <div className="m-5">
        <span className="pr-2">Sie sind hier:</span>
        {breadcrumbs.map((breadcrumb, index) => (
          <span key={breadcrumb.url}>
            {index > 0 && <span className="px-2">&gt;</span>}

            {breadcrumb.url ? (
              (<Link href={breadcrumb.url} className="text-brand-700">

                {typeof breadcrumb.title === "string"
                  ? breadcrumb.title
                  : breadcrumb.title(t)}

              </Link>)
            ) : (
              <>{breadcrumb.title}</>
            )}
          </span>
        ))}
      </div>

      <hr />

      <StructuredDataTag
        data={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: breadcrumbs.map((breadcrumb, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name:
              typeof breadcrumb.title === "string"
                ? breadcrumb.title
                : breadcrumb.title(t),
            item: breadcrumb.url
              ? `${getOriginUrl()}${breadcrumb.url}`
              : undefined,
          })),
        }}
      />
    </div>
  );
}

export default Breadcrumbs;
